import React , {useState} from 'react';
import { Button, Modal, Row  , Col , Table, Input} from 'antd';
import { sendNotificationToRedBus } from './red-bus-activation.module';
import { useEffect } from 'react';
import { getViaCities } from '../../actions/home.action';
import { isValid } from '../../utils/utilities';
import { loadingAction } from '../../actions/loading-actions';
import { useDispatch } from 'react-redux';
import './red-bus-activation.style.scss';


export const RedBusActivation = (props) => {


    const {
        scheduleId
    } = props;


    const [rowKeys,setRowKeys] = useState([]);
    const [selectedRows,setSelectedRows] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [routes, setRoutes] = useState([]);
    const [searchText, setSearchText] = useState({
        origin: '',
        destination: ''
    });

    const dispatch = useDispatch();

    useEffect(()=>{
        if(isValid(scheduleId)){
            getViaCities(scheduleId,(data)=>{
                setRoutes(data);
            },()=>{
            });
        }
    },[scheduleId]);

    const setLoading=(bool)=>{
        dispatch(loadingAction(bool));
    }

    const onSuccess=()=>{
        handleOk();
        setSelectedRows([]);
        setRowKeys([]);
        setLoading(false);
    }

    const onFailure=()=>{
        setLoading(false);
    }

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    // const handleEmail = () => {
    //     if (selectedRows.length>0) {
    //         emailOTAs(selectedRows);
    //         setIsModalVisible(false);
    //     }
    //     else {
    //         message.warn("Please select atleast one route to send email")
    //     }
    // }

    const onSubmit=(e)=>{
        e.preventDefault();
        setLoading(true);
        sendNotificationToRedBus(selectedRows,onSuccess,onFailure);
    }

    // Get unique filter options
    const getFilterOptions = (field) => {
        return [...new Set(routes.map(route => route[field]))].map(value => ({
            text: value,
            value: value
        }));
    };

    // Custom filter dropdown with search
    const getColumnSearchProps = (dataIndex) => {
        const options = getFilterOptions(dataIndex);
        return {
            filters: options,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder={`Search ${dataIndex}`}
                        value={searchText[dataIndex]}
                        onChange={(e) => {
                            setSearchText({
                                ...searchText,
                                [dataIndex]: e.target.value
                            });
                        }}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <div style={{ maxHeight: 200, overflow: 'auto' }}>
                        {options
                            .filter(option => 
                                option.text.toLowerCase().includes(searchText[dataIndex].toLowerCase())
                            )
                            .map(option => (
                                <div
                                    key={option.value}
                                    style={{
                                        padding: '5px 12px',
                                        cursor: 'pointer',
                                        background: selectedKeys.includes(option.value) ? '#e6f7ff' : 'transparent'
                                    }}
                                    onClick={() => {
                                        const keys = selectedKeys.includes(option.value)
                                            ? selectedKeys.filter(key => key !== option.value)
                                            : [...selectedKeys, option.value];
                                        setSelectedKeys(keys);
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedKeys.includes(option.value)}
                                        onChange={() => {}}
                                        style={{ marginRight: 8 }}
                                    />
                                    {option.text}
                                </div>
                            ))
                        }
                    </div>
                    <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                clearFilters();
                                setSearchText({
                                    ...searchText,
                                    [dataIndex]: ''
                                });
                            }}
                        >
                            Reset
                        </Button>
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => confirm()}
                        >
                            OK
                        </Button>
                    </div>
                </div>
            ),
            onFilter: (value, record) => record[dataIndex] === value
        };
    };

    let columns =[
        {
            title: 'Origin',
            dataIndex: 'origin',
            key: 'origin',
            ...getColumnSearchProps('origin')
        },
        {
            title: 'Destination',
            dataIndex: 'destination',
            key: 'destination',
            ...getColumnSearchProps('destination')
        }
    ];

    const rowSelection = {
        selectedRowKeys: rowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
         setRowKeys(selectedRowKeys);
         setSelectedRows(selectedRows);
        },
        getCheckboxProps: record => ({
          disabled: record.name === 'Disabled User', // Column configuration not to be checked
          name: record.name,
        }),
      };

  return (
      <div>
            <Row justify="center" align="middle">
                <Button type="primary" onClick={showModal}
                    className='register-new-routes-in-OTA-btn'
                >
                    Register New<br />Routes in OTA
                </Button>
            </Row>
          <Modal title="OTA Alert" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} footer={null}>
            <Table
                rowSelection={rowSelection}
                rowKey={record => record.origin+record.destination}
                dataSource={routes}
                columns={columns}
                pagination={false}
                />
             <Row gutter={[16,16]} style={{paddingTop:'10px'}} justify="end">
                 <Col>
                    <Button onClick={handleCancel} className="exit-btn">Close</Button>
                 </Col>
                 <Col>
                    <Button onClick={onSubmit} type="primary">Register in Redbus</Button>
                 </Col>
             </Row>
          </Modal>
      </div>
  );
};